import React from "react";
import { Modal, Card, Row, Col, Typography, Button } from "antd";
import { FileTextOutlined, EditOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

/**
 * 模板选择对话框组件
 * 用于在发送确认邮件时选择新计划或更新计划模板
 */
const TemplateSelectionModal = ({ visible, onSelect, onCancel }) => {
    const templateOptions = [
        {
            code: "SCHEDULE_AAE_NEW_CONFIRMATION",
            title: "新发布计划确认",
            description: "用于首次发布的航班计划确认邮件",
            icon: <FileTextOutlined style={{ fontSize: 24, color: "#1890ff" }} />,
            example: "Schedule for 9H-FLM & 9H-WFF on 01JUN-30JUN",
            type: "new",
        },
        {
            code: "SCHEDULE_AAE_UPDATE_CONFIRMATION", 
            title: "更新计划确认",
            description: "用于已发布计划的变更确认邮件",
            icon: <EditOutlined style={{ fontSize: 24, color: "#52c41a" }} />,
            example: "Schedule update for 9H-FLM & 9H-WFF on 16JUN-19JUN (due to operational requirements)",
            type: "update",
        },
    ];

    const handleSelectTemplate = (templateCode) => {
        onSelect(templateCode);
    };

    return (
        <Modal
            title="选择邮件模板"
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={800}
            destroyOnHidden
        >
            <div style={{ marginBottom: 16 }}>
                <Text type="secondary">
                    请选择适合的邮件模板类型。新发布计划用于首次发送，更新计划用于已发布计划的变更通知。
                </Text>
            </div>
            
            <Row gutter={[16, 16]}>
                {templateOptions.map((template) => (
                    <Col span={12} key={template.code}>
                        <Card
                            hoverable
                            style={{ height: "100%" }}
                            onClick={() => handleSelectTemplate(template.code)}
                            bodyStyle={{ 
                                padding: 20,
                                display: "flex",
                                flexDirection: "column",
                                height: "100%"
                            }}
                        >
                            <div style={{ 
                                display: "flex", 
                                alignItems: "center", 
                                marginBottom: 12 
                            }}>
                                {template.icon}
                                <Title level={4} style={{ margin: 0, marginLeft: 12 }}>
                                    {template.title}
                                </Title>
                            </div>
                            
                            <Text type="secondary" style={{ marginBottom: 12, flex: 1 }}>
                                {template.description}
                            </Text>
                            
                            <div style={{ 
                                backgroundColor: "#f5f5f5", 
                                padding: 8, 
                                borderRadius: 4,
                                marginBottom: 12 
                            }}>
                                <Text code style={{ fontSize: 12 }}>
                                    示例主题: {template.example}
                                </Text>
                            </div>
                            
                            <Button 
                                type="primary" 
                                block
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleSelectTemplate(template.code);
                                }}
                            >
                                使用此模板
                            </Button>
                        </Card>
                    </Col>
                ))}
            </Row>
            
            <div style={{ textAlign: "center", marginTop: 16 }}>
                <Button onClick={onCancel}>
                    取消
                </Button>
            </div>
        </Modal>
    );
};

export default TemplateSelectionModal; 